import { render, staticRenderFns } from "./AiLaw.vue?vue&type=template&id=7c5e9c18&scoped=true"
import script from "./AiLaw.vue?vue&type=script&lang=js"
export * from "./AiLaw.vue?vue&type=script&lang=js"
import style0 from "./AiLaw.vue?vue&type=style&index=0&id=7c5e9c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c5e9c18",
  null
  
)

export default component.exports